module.exports = __webpack_public_path__ + "static/media/security-check_8.49a2c8d2.png";